import {
  DownCircleFilled,
  PlusOutlined,
  ClusterOutlined,
} from "@ant-design/icons";
import { Row, Button, Table, message, Spin, Dropdown } from "antd";
import { environment_library_column } from "../../../constants/Table Columns";
import React, { useEffect, useState } from "react";
import "../../../styles/db.css";
import PageHeader from "../../../components/generic/PageHeader";
import EnvironmentModalNew from "./EnvironmentModalNew";
import {
  deleteEnvironmentByName,
  getAllEnvironment,
  getDataSubTypeByType,
} from "../../../service/admin.service";
import EnvironmentModalView from "./EnvironmentModalView";
import { getConnectionByName } from "../../../service/db.service";

function EnvironmentLibrary() {
  const [newModalVisible, setNewModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [environmentList, setEnvironmentList] = useState([]);
  const [environmentVariable, setEnvironmentVariable] = useState([]);
  const [existingDbDetails, setExistingDbDetails] = useState([]);
  const [environmentName, setEnvironmentName] = useState("");
  const [folderLoadComplete, setFolderLoadComplete] = useState(false);
  const [dbLoadComplete, setDbLoadComplete] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  useEffect(() => {
    getEnvironmentList();
  }, []);
  useEffect(() => {
    if (folderLoadComplete && dbLoadComplete) {
      setModalLoading(false);
      setViewModalVisible(true);
      setFolderLoadComplete(false);
      setDbLoadComplete(false);
    }
  }, [folderLoadComplete, dbLoadComplete]);
  const getEnvironmentList = () => {
    getAllEnvironment().then((res) => {
      if (res.status !== 200) {
        message.error("Something went wrong!");
      } else {
        setEnvironmentList(res.data);
      }
    });
  };
  const onClickNew = () => {
    setNewModalVisible(!newModalVisible);
  };
  const updateEnvironmentList = () => {
    getEnvironmentList();
  };
  const deleteEnvironment = (displayName) => {
    deleteEnvironmentByName(displayName).then((res) => {
      if (res.status !== 200) {
        message.error("something went wrong!");
      } else {
        message.success(`Record ${displayName} deleted successfully!`);
        getEnvironmentList();
      }
    });
  };
  const onClickEditEnvironment = (record) => {
    setModalLoading(true);
    setEnvironmentName(record.displayName);
    setFolderLoadComplete(false);
    setDbLoadComplete(false);
    getEnvironmentVariables(record.displayName);
    getDbDetails(record.displayName);
  };
  const handleViewModalClose = () => {
    setViewModalVisible(false);
    setEnvironmentVariable([]);
    setExistingDbDetails([]);
  };
  const getEnvironmentVariables = (envName) => {
    getDataSubTypeByType("Environment", envName)
      .then((res) => {
        if (res.status === 200) {
          setEnvironmentVariable(res.data || []);
        }
        setFolderLoadComplete(true);
      })
      .catch((err) => {
        setEnvironmentVariable([]);
        setFolderLoadComplete(true);
      });
  };
  const getDbDetails = (envName) => {
    getConnectionByName(envName)
      .then((res) => {
        if (res.status === 200) {
          setExistingDbDetails(res.data || []);
        }
        setDbLoadComplete(true);
      })
      .catch((err) => {
        setDbLoadComplete(true);
        setExistingDbDetails([]);
      });
  };
  const modifiedColumns = environment_library_column.map((col) => {
    if (col.key === "options") {
      return {
        ...col,
        render: (_, record) => (
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  label: "View",
                  onClick: () => onClickEditEnvironment(record),
                },
                {
                  key: "2",
                  label: "Delete",
                },
              ],
            }}
            overlayClassName="table-row-actions-dropdown"
          >
            <a className="table-more-options">
              Options <DownCircleFilled />
            </a>
          </Dropdown>
        ),
      };
    }
    return col;
  });
  return (
    <div>
      <PageHeader
        backTo="/admin"
        icon={<ClusterOutlined />}
        title="Environment Library"
        tooltip="Manage environments, folder paths and database connections"
        actions={
          <Button className="db-add" icon={<PlusOutlined />} onClick={onClickNew}>
            New Environment
          </Button>
        }
      />
      <div>
        <EnvironmentModalNew
          openModal={onClickNew}
          isOpen={newModalVisible}
          environmentList={environmentList}
          updateEnvironmentList={updateEnvironmentList}
          envName={environmentName}
        />
      </div>
      <div>
        {modalLoading ? (
          <Spin size="large" />
        ) : (
          <EnvironmentModalView
            isOpen={viewModalVisible}
            environmentName={environmentName}
            handleModal={onClickEditEnvironment}
            handleModalClose={handleViewModalClose}
            existingFolderData={environmentVariable}
            existingDbDetails={existingDbDetails}
            updateEnvironmentList={updateEnvironmentList}
          />
        )}
      </div>
      <Row className="table-container">
        <Table
          columns={modifiedColumns}
          dataSource={environmentList}
          pagination={{
            defaultPageSize: "10",
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30"],
          }}
        />
      </Row>
    </div>
  );
}

export default EnvironmentLibrary;
